export default {"src":"/polygon/_next/static/media/stader_logo_dark.55a7e282.svg","height":33,"width":20};